import { Stack, Typography } from "@mui/material";
import i18n from "../../../../../i18n";
import { BulbIcon, DurationIcon } from "../assets";
import styles from "./SidePanel.module.css";

export default function SidePanel() {
	return (
		<Stack gap="18px">
			<div className={styles.videoCard}>
				<div className={styles.video}>
					<iframe src="https://marketing.video.yuja.com/V/Video?v=15695953&node=67703127&a=115940241" allowFullScreen />
				</div>
				<Stack padding="20px 15px" gap="8px">
					<Typography className={styles.videoTitle}>
						{i18n.t("candidate.scheduleInterview.sidePanel.video.title")}
					</Typography>
					<Typography className={styles.videoDescription}>
						{i18n.t("candidate.scheduleInterview.sidePanel.video.description")}
					</Typography>
					<Stack direction="row" gap="8px" alignItems="center">
						<DurationIcon />
						{/* GET DURATION */}
						<Typography className={styles.videoTime}>
							{i18n.t("candidate.scheduleInterview.sidePanel.video.duration", { time: "2:00" })}
						</Typography>
					</Stack>
				</Stack>
			</div>
			<div className={styles.tipCard}>
				<Stack direction="row" gap="8px" alignItems="center">
					<BulbIcon />
					<Typography className={styles.tipTitle}>
						{i18n.t("candidate.scheduleInterview.sidePanel.tip.title")}
					</Typography>
				</Stack>
				<Typography className={styles.tipDescription}>
					{i18n.t("candidate.scheduleInterview.sidePanel.tip.description")}
				</Typography>
			</div>
		</Stack>
	);
}
